import(/* webpackMode: "eager" */ "/home/runner/work/frontend/frontend/apps/viewup/app/error.tsx");
